import $ from 'jquery';
import 'jquery-validation';
import 'jquery-validation-unobtrusive';
import CardExpiryService from '../payment/CardExpiryService';

const registerCardExpiryRule = () => {
    const ruleName = 'cardexpiry';
    const cardExpiryService = new CardExpiryService();
    $.validator.addMethod(ruleName, (value, element, params) => {
        cardExpiryService.createCardExpiry(value);
        return !cardExpiryService.isExpired;
    });

    // Add jQuery validation unobtrusive adapter
    // We still need attach empty parameter [] to get client validation work.
    $.validator.unobtrusive.adapters.add(ruleName, [], options => {
        options.rules[ruleName] = options.params;
        options.messages[ruleName] = options.message;
    });
};

export default registerCardExpiryRule;
